import { Action, createAction } from 'redux-act';

import Address from '../../../models/interfaces/Address';
import PlaceName from '../../../models/interfaces/PlaceName';
import TimestampPayload from '../TimestampPayload';

export interface AddPlacePayload {
  uuid: string;
  placeUuid: string;
  companyUuid: string;
  name: string;
  uniqueName: string;
  address: Address;
}
export const addPlace = createAction<AddPlacePayload>('ADD_PLACE');
export type InitializePlaceActionType = Action<AddPlacePayload>;

export interface PlaceInitilizedPayload extends TimestampPayload {
  placeName: PlaceName;
}
export const placeAdded = createAction<PlaceInitilizedPayload>('PLACE_ADDED');

export interface PlaceInitilizeFailedPayload extends TimestampPayload {
  placeName: PlaceName;
}
export const placeAdditionFailed = createAction<PlaceInitilizeFailedPayload>('PLACE_ADDITION_FAILED');
